import { SessionService } from './../services/session.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree { 
     
    if (this.sessionService.hasFetrapiSession()) {
      const allowedRoles = next.data["roles"];
      const maingroupName = this.sessionService.getMaingroupName();
      return allowedRoles.includes(maingroupName) ? true : this.router.navigate(['/']);
    } else {
      return this.router.navigate(['/']);
    }

  }
}
